import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import close from '../../../../assets/images/bluecross.svg';

export default function AddRoleModal(props) {
  const {
    handleToggleModalState,
    parentModalState,
    handleAddRole,
    selectedRole,
    type,
    handleRefresh,
    // handleToggleTemplateStylingModal,
    handleSetSelected
  } = props;

  const apiUrl = process.env.REACT_APP_API_URL;
  const apiKey = process.env.REACT_APP_API_KEY;

  const [attachment, setAttachment] = useState(null);
  const [modalState, setModalState] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [file, setFile] = useState(null);
  const [isAnonymised, setIsAnonymised] = useState(true);
  const [uploadError, setUploadError] = useState('');

  const handleModalStateChange = () => {
    handleToggleModalState(!parentModalState);
  }

  // const handleToggleTemplateStylingModalChange = () => {
  //   handleToggleTemplateStylingModal();
  // }

  const handleAttachmentChange = (e) => {
    const selectedAttachment = e.target.files && e.target.files.length > 0 ? e.target.files[0] : null;

    if (type === 'template' && selectedAttachment) {
      const extension = selectedAttachment.name.split('.').pop()?.toLowerCase();

      if (extension !== 'docx') {
        setAttachment(null);
        setUploadError('You must upload templates as a DOCX.');
        e.target.value = '';
        return;
      }
    }

    setUploadError('');
    setAttachment(selectedAttachment);
  };

  const handleUpload = async (nextIsAnonymised) => {
    if (attachment) {
      console.log("Uploading attachment...");

      const formData = new FormData();
      formData.append("file", attachment);
      formData.append("job_id", selectedRole.id);
      formData.append("file_name", attachment.name);
      if (type === 'resume') {
        formData.append("is_anonymised", nextIsAnonymised ? "1" : "0");
      }

      try {
        setIsLoading(true);
        const result = await fetch(`${apiUrl}/formatter/${type}/upload`, {
          method: "POST",
          body: formData,
          headers: {
            "x-api-key": `${apiKey}`,
          },
          mode: 'cors',
        })
        const data = await result.json();

        if (type === 'template') {
          handleSetSelected(data.data.data);
        }
        setIsLoading(false);
        await handleRefresh();
        handleModalStateChange();

        // if (type == 'template') {
        //   handleToggleTemplateStylingModalChange();
        // }
        return data;
      } catch (error) {
        return error;
      }
    }
  };

  return createPortal((
    <section className='upload-file-modal'>
      <div className='background' />
      <div className='upload-file-modal__inner'>
        <h2>Upload a {type}</h2>
        <img src={close} onClick={handleModalStateChange} alt="Close" />
        {isLoading === true && <div className="spinner"><div class="lds-dual-ring"></div></div>}
        {isLoading === false && <div className="upload-file-body">
          {type === 'template' && <p className="upload-file-helper">Templates must be uploaded as a DOCX file.</p>}
          <input
            id="attachment"
            type="file"
            accept={type === 'template' ? '.docx' : undefined}
            onChange={handleAttachmentChange}
          />
          {uploadError && <p className="upload-file-error">{uploadError}</p>}
          {type === 'resume' && <div className="upload-file-toggle">
            <span className="upload-file-toggle__label">Resume mode</span>
            <div className="upload-file-toggle__options">
              <label className={isAnonymised ? "active" : "inactive"}>
                <input
                  type="radio"
                  name="resume-visibility"
                  checked={isAnonymised === true}
                  onChange={() => setIsAnonymised(true)}
                />
                <span>Anonymised</span>
              </label>
              <label className={!isAnonymised ? "active" : "inactive"}>
                <input
                  type="radio"
                  name="resume-visibility"
                  checked={isAnonymised === false}
                  onChange={() => setIsAnonymised(false)}
                />
                <span>Non-anonymised</span>
              </label>
            </div>
          </div>}
        </div>}
        <button className={`button ${(!attachment) ? "disabled" : ""}`} disabled={!attachment} onClick={() => handleUpload(isAnonymised)}>
          Upload Attachment
        </button>
      </div>
    </section >
  ), document.body);
}
